<div class="flex flex-col gap-5">
  @if (locationState(); as location) {
    <div class="flex gap-3">
      <form
        (submit.prevent)="onChangeFilter()"
        class="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3"
      >
        <ui-input-simple
          [placeholder]="'cockpit.energyInterfaces.page.searchPlaceholder' | transloco"
          [formField]="filterForm.query"
          (fieldValueChange)="onChangeFilter()"
        >
          <div slot="start" class="text-on-surface-disabled">
            <ng-icon name="heroMagnifyingGlass" size="16" class="!block" />
          </div>
        </ui-input-simple>
        <ui-select
          [formField]="filterForm.utilityType"
          (selectChange)="onChangeFilter()"
          class="hidden md:inline"
        >
          <option value="" [selected]="!filter().utilityType">
            {{ 'cockpit.energyInterfaces.page.filterAllTypesLabel' | transloco }}
          </option>
          <option value="GAS" [selected]="filter().utilityType === 'GAS'">
            {{ 'cockpit.energyInterfaces.page.filterGasLabel' | transloco }}
          </option>
          <option value="ELECTRICITY" [selected]="filter().utilityType === 'ELECTRICITY'">
            {{ 'cockpit.energyInterfaces.page.filterElectricityLabel' | transloco }}
          </option>
        </ui-select>

        <ui-simple-dialog #mobileFilterDialog>
          <ui-simple-dialog-layout class="w-full" (clickCancel)="mobileFilterDialog.close()">
            <ng-container slot="title">
              {{ 'cockpit.energyInterfaces.page.mobileFilterDialogTitle' | transloco }}
            </ng-container>
            <div class="flex flex-col gap-6">
              <ui-select [formField]="filterForm.utilityType" (selectChange)="onChangeFilter()">
                <option value="" [selected]="!filter().utilityType">
                  {{ 'cockpit.energyInterfaces.page.filterAllTypesLabel' | transloco }}
                </option>
                <option value="GAS" [selected]="filter().utilityType === 'GAS'">
                  {{ 'cockpit.energyInterfaces.page.filterGasLabel' | transloco }}
                </option>
                <option value="ELECTRICITY" [selected]="filter().utilityType === 'ELECTRICITY'">
                  {{ 'cockpit.energyInterfaces.page.filterElectricityLabel' | transloco }}
                </option>
              </ui-select>
            </div>
          </ui-simple-dialog-layout>
        </ui-simple-dialog>
      </form>
      <ui-button
        class="hidden md:inline flex-none"
        type="button"
        (click)="createEnergyInterfaceDialog.showModal()"
        expand="full"
      >
        <ng-icon slot="start" name="heroServer" size="20" class="!block" />
        {{ 'cockpit.energyInterfaces.page.addEnergyInterfaceButton' | transloco }}
      </ui-button>
      <ui-button
        [iconOnly]="true"
        mode="outlined"
        class="md:hidden flex-none"
        [ariaLabel]="'cockpit.energyInterfaces.page.mobileFilterOpenButton' | transloco"
        (click)="mobileFilterDialog.showModal()"
      >
        <ng-icon name="heroFunnel" size="20" class="!block" />
      </ui-button>
      <ui-button
        [iconOnly]="true"
        class="md:hidden flex-none"
        [ariaLabel]="'cockpit.energyInterfaces.page.addEnergyInterfaceButton' | transloco"
        (click)="createEnergyInterfaceDialog.showModal()"
      >
        <ng-icon name="heroPlus" size="20" class="!block" />
      </ui-button>
    </div>

    @if (energyInterfacesStore.isLoading()) {
      <app-energy-interface-list-skeleton />
    } @else if (energyInterfacesStore.error()) {
      <app-error-page
        [error]="energyInterfacesStore.error()"
        (clickBack)="router.navigate(['/organizations', organizationId(), 'locations'])"
        class="block"
        style="height: calc(100vh - 30rem)"
      />
    } @else {
      @if (filteredEnergyInterfaces().length > 0) {
        <app-energy-interface-list>
          @for (energyInterface of filteredEnergyInterfaces(); track energyInterface.id) {
            <app-energy-interface-list-entry
              [energyInterface]="energyInterface"
              [organizationId]="organizationId() ?? ''"
            />
          }
        </app-energy-interface-list>
      } @else if (energyInterfaces().length > 0) {
        <app-energy-interface-list-no-results (clickReset)="onClickResetFilter()" />
      } @else {
        <app-energy-interface-list-empty
          (clickCreate)="createEnergyInterfaceDialog.showModal()"
          class="block w-full"
        />
      }
    }

    <ui-simple-dialog #createEnergyInterfaceDialog>
      <app-energy-interface-create-dialog
        [locationId]="location.id"
        class="w-full"
        (clickCancel)="createEnergyInterfaceDialog.close()"
        (createSuccess)="onCreateSuccess(createEnergyInterfaceDialog, $event)"
      />
    </ui-simple-dialog>
  }
</div>
